import AppIndex from 'src/pages/AppIndex.vue'

import { devMode } from 'src/config'
import { storageService } from 'src/services/app/storage.service'
import {
  getCompanyEditSteps,
  getCompanyDetailsTabs,
  COMPANY_DETAILS_TABS,
  COMPANY_EDIT_STEPS,
} from 'src/services/consts/company.const'
import { ROUTES } from 'src/services/consts/routes.const'
import { STORAGE_KEYS } from 'src/services/consts/api.const'

// Add a key for storing the last filter state
const routes = [
  {
    path: '/',
    name: ROUTES.APP,
    redirect: ROUTES.COMPANY,
    component: AppIndex,
    children: [
      {
        path: ROUTES.COMPANY,
        name: ROUTES.COMPANY,
        component: () => import('src/pages/companies/CompaniesIndex.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: ROUTES.CREATION_REQUESTS,
        name: ROUTES.CREATION_REQUESTS,
        component: () => import('src/pages/creation-request/CreationRequestsIndex.vue'),
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: ROUTES.NOTIFICATIONS_POC,
        name: ROUTES.NOTIFICATIONS_POC,
        component: () => import('src/pages/NotificationsPOC.vue'),
        meta: { requiresAuth: true, devOnly: true },
        beforeEnter: () => {
          if (!devMode) return { name: ROUTES.COMPANY }
        },
      },
      {
        path: ROUTES.COMPANY + '/:id/:tab?',
        name: ROUTES.COMPANY_INFO,
        component: () => import('src/pages/company/CompanyDetails.vue'),
        meta: {
          requiresAuth: true,
        },
        beforeEnter: (to) => {
          const tab = to.params.tab
          const detailTabs = getCompanyDetailsTabs()
          if (!detailTabs.some((t) => t.name === tab)) {
            return {
              name: ROUTES.COMPANY_INFO,
              params: { id: to.params.id, tab: COMPANY_DETAILS_TABS.INFO },
            }
          }
        },
      },
      {
        path: ROUTES.COMPANY + '/:id/edit/:step?',
        name: ROUTES.COMPANY_EDIT,
        component: () => import('src/pages/company/CompanyEdit.vue'),
        meta: {
          requiresAuth: true,
          requiresWrite: true,
        },
        beforeEnter: (to) => {
          const step = to.params.step
          const editSteps = getCompanyEditSteps()
          if (!editSteps.some((s) => s.name === step)) {
            return {
              name: ROUTES.COMPANY_EDIT,
              params: { id: to.params.id, step: COMPANY_EDIT_STEPS.INFO },
            }
          }
        },
      },
    ],
  },

  // Auth is handled separately
  {
    path: '/' + ROUTES.LOGIN,
    name: ROUTES.LOGIN,
    beforeEnter: () => {
      const user = storageService.get(STORAGE_KEYS.LOGGED_IN_USER)
      if (user) {
        return '/'
      }
    },
    component: () => import('src/pages/auth/LoginPage.vue'),
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/ErrorNotFound.vue'),
  },
]

export default routes
